import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '../services/layout.service';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, NavbarComponent],
  template: `
    <div class="layout-wrapper d-flex">
      <!-- 1. Sidebar -->
      <app-sidebar></app-sidebar>

      <!-- 2. Main Content Area -->
      <main
        class="main-content flex-grow-1 min-vh-100 d-flex flex-column bg-light"
      >
        <!-- Navbar -->
        <app-navbar></app-navbar>

        <!-- Route Content -->
        <div class="page-body flex-grow-1 overflow-auto">
          <router-outlet></router-outlet>
        </div>

        <!-- Footer (Optional) -->
        <!-- <footer
          class="mt-auto py-3 px-4 bg-white border-top small text-secondary"
        >
          &copy; 2026 Cloud Camera Project. All rights reserved.
        </footer> -->
      </main>
    </div>
  `,
  styles: [
    `
      @use 'styles/variables' as v;
      @use 'styles/mixins' as m;

      .layout-wrapper {
        display: flex;
        height: 100vh;
        min-height: 100vh;
        overflow: hidden;
      }

      .main-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        height: 100vh;
        overflow: hidden;
      }

      .page-body {
        flex: 1;
        background-color: #f7f9fe;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 1.25rem;
      }

      @media (min-width: 1200px) {
        .page-body {
          padding: 1.5rem;
        }
      }
    `,
  ],
})
export class MainLayoutComponent {
  layoutService = inject(LayoutService);
}
